<template>
  <div class="item_area">
    <div class="summary">
      <dl class="section">
        <dt>보유 연승 스탬프</dt>
        <dd class="c_stamp">{{ totalEntries }}</dd>
      </dl>
      <div class="btn_area">
        <router-link :to="{ path: path, query : { page:page, type : 'all' } }" class="tab btn" :class="{selected:type === 'all'}" onclick="gaEventer('마이페이지 - 연승 스탬프', '전체')">전체 ( {{ totalCount }} )</router-link>
        <router-link :to="{ path: path, query : { page:page, type : '5' } }" class="tab btn" :class="{selected:type === '5'}" onclick="gaEventer('마이페이지 - 연승 스탬프', '스탬프 5')">스탬프 5</router-link>
        <router-link :to="{ path: path, query : { page:page, type : '10' } }" class="tab btn" :class="{selected:type === '10'}" onclick="gaEventer('마이페이지 - 연승 스탬프', '스탬프 10')">스탬프 10</router-link>
        <router-link :to="{ path: path, query : { page:page, type : '20' } }" class="tab btn" :class="{selected:type === '20'}" onclick="gaEventer('마이페이지 - 연승 스탬프', '스탬프 20')">스탬프 20</router-link>
      </div>
    </div>
    <div class="item_list" v-if="list.length || !loaded">
      <div class="item" v-for="(value, index) in list" :key="index">
        <dl class="info_area stamp">
          <dt>
            <img :src="value.imageUrl" :alt="value.name"/>
            <span class="name">{{ value.name }} ({{value.stampAmount +'/'+ value.maxAmount}}) </span>
            <stamp-page
              :totalCount="value.stampAmount"
              :stampAmount="value.stampAmount"
            ></stamp-page>
          </dt>
          <a class="btn gift" href="javascript:;" v-on:click="itemOpen(value.id)"
             v-if="value.maxAmount === value.stampAmount">아이템 받기</a>
          <a class="btn use" href="javascript:;" v-on:click="useStamp(value.id, value.status)"
             v-else-if="value.status === 1">사용하기</a>
          <a class="btn used" href="javascript:;" v-on:click="useStamp(value.id, value.status)" v-else>사용중</a>
        </dl>
      </div>
    </div>
    <div class="no_history" v-else>
      보유하신 스탬프가 없습니다.
    </div>
    <pagenation
      :total-count="totalEntries"
      :page-size="pageSize"
      :page="page"
      :condition="condition"
      v-show="list.length && loaded"
    ></pagenation>
  </div>
</template>

<script>
  import _ from 'lodash'
  import common from '../../mixins/common'
  import pagenation from '../pagenation'
  import stampPage from './stamp-page'
  export default {
    name: 'stamp-wrap',
    components: {
      pagenation,
      stampPage
    },
    mixins: [
      common
    ],
    data() {
      return {
        loaded: false,
        page: this.$route.query.page ? this.$route.query.page : 1,
        totalEntries: 0,
        totalPage: 1,
        totalCount: 0,
        pageSize : 12,
        list: [],
        type: this.$route.query.type ? this.$route.query.type : 'all',
        path: this.$route.path,
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {

        let res = await this._get("/v1/stamp", {
          page: this.page,
          type: this.type
        })

        this.list = res.data.data;
        this.loaded = true;
        this.list.forEach(v => {
          v.totalPage = Math.ceil(v.stampAmount / 5);
          v.stampCurrPage = 1;
          v.stampCurrAmount = v.stampAmount;
        });
        this.totalCount = res.data.totalCount;
        this.totalPage = res.data.totalPage;
        this.totalEntries = res.data.totalEntries;

      },
      async useStamp(id, status) {

        let res = await this._post("/v1/stamp/use", {
          stampId: id,
          status: status
        });

        if (res.data.error) {
          alert(res.data.message);
          return false;
        }

        let index = _.findIndex(this.list, {'id': res.data.id});
        if (index > -1) {
          let item = this.list[index];
          item.status = res.data.status;
          this.list.splice(index, 1, item);
        }
        if (status === 1) {
          alert(res.data.name + '가 활성화 되었습니다.');
        } else {
          alert(res.data.name + '가 비활성화 되었습니다.');
        }

      },
      async itemOpen(id) {
        let res = await this._post("/v1/stamp/open", {
          stampId: id
        })

        if (res.data.error) {
          alert(res.data.message);
          return false;
        }

        let index = _.findIndex(this.list, {'id': id});
        if (index > -1) {
          this.list.splice(index, 1);
        }

        alert(res.data.message);
      },
      tradeStatusText(tradeCount){
        return tradeCount <= 0 ? '(거래불가)' : ''
      },
      stampPaging(value, index, pagingValue) {
        const selector = pagingValue === 1 ? 'right' : 'left';
        const isInactiveArrow  = this.$refs[selector][index].className.indexOf('inactive') > -1;
        if (isInactiveArrow) {
          return;
        }
        const totalPage = value.maxAmount / 5;
        const limitPage = pagingValue === 1 ? totalPage : 1;
        const tempObj = this.list[index];
        tempObj.stampCurrPage = tempObj.stampCurrPage === limitPage   ? limitPage : tempObj.stampCurrPage + pagingValue;
        tempObj.stampCurrAmount = tempObj.stampCurrPage === totalPage
          ? tempObj.stampAmount % 5 ? tempObj.stampAmount % 5 : tempObj.stampAmount === 0 ? 0 : 5
          : tempObj.stampAmount === 0 ? 0 : 5;
        this.list.splice(index, 1, tempObj);
      },
    },


    computed: {
      condition() {
        return {
          type: this.type
        }
      }
    },
    watch: {
      '$route'(to) {
        this.page = to.query.page ? parseInt(to.query.page) : 1;
        this.type = this.$route.query.type ? this.$route.query.type : 'all';
        this.getList();
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/mypage/stamp-wrap.vue